import * as React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import { useMediaQuery, useTheme } from "@mui/material";
import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
import RouteGuard from "./RouteGuard";
import Header from "./Components/Header/Header";
import { useAuthenticator, Authenticator } from "@aws-amplify/ui-react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

//Demo
import Demo from "./Pages/Demo/Demo";
//ROI

import ROICalculatorPage from './Pages/ROICalculator';

//Blog
import { BlogListPage, BlogDetailPage } from './Pages/Blog';


//ComingSoon
import ComingSoon from "./Pages/AdditionalPages/ComingSoon";

//Legal
import PrivacyPolicyPage from "./Pages/Legal/PrivacyPolicyPage";
import TermsOfServicePage from "./Pages/Legal/TermsOfServicePage";
import CommunityGuidelinesPage from "./Pages/Legal/CommunityGuidelinesPage";
import CookiePolicyPage from "./Pages/Legal/CookiePolicyPage";
import AboutPage from "./Pages/Legal/AboutPage";

//Pricing
import Pricing from "./Pages/Pricing/Pricing";
import SubscriptionSuccessPage from "./Pages/Pricing/SubscriptionSuccessPage";

//Landing pages
import LandingBusinessPage from "./Pages/Landing/StartBusinessPage/StartBusinessPage";
import LandingUsersPage from "./Pages/Landing/Start/StartPage";
import LandingNewBusinessPage from "./Pages/Landing/NewBusinessLanding/NewBusinessPage";
import LandingAIToolsPage from "./Pages/Landing/AIToolsLandingPage/AIToolsPage";
import BusinessLandingPage from './Pages/Landing/Business/BusinessLandingPage';
import StartupLandingPage from './Pages/Landing/Startups/StartupLandingPage';


//Auth
import SignIn from "./Pages/Auth/SignIn";
import SignOut from "./Pages/Auth/SignOut";

import AffiliateRedirect from "./Pages/Affiliate/AffiliateRedirect"
import AffiliatesPage from './Pages/Affiliate/AffiliatesPage';
import FoundersCirclePage from './Pages/FoundersCircle/FoundersCirclePage';

import MarketingRedirect from "./Pages/Marketing/MarketingRedirect"




import PreviewRedirect from "./Pages/Preview/PreviewRedirect"
import BatchReview   from './Pages/Drafts/BatchReview';
import TokenRedirectPage from './Pages/Drafts/TokenRedirect';





//UserProfile
import ActiveUserProfile from "./Pages/UserProfile/ActiveUserProfile";

//ProvidersSerachResults
import SearchResultsPage from "./Pages/ProvidersSerachResults/SearchResultsPage";
import FindBusinessPage from "./Pages/ProvidersSerachResults/FindBusinessPage";

import DraftApprovalPage from './Pages/Drafts/DraftApprovalPage';
import SocialContentPage from './Pages/Social/SocialContentPage';
import SocialAccountsPage from './Pages/Social/SocialAccountsPage';
import BusinessKnowledgeBasePage from './Pages/BusinessDocs/BusinessKnowledgeBasePage';




//UsersSerachResults
import SearchInvitePage from "./Pages/MyNetwork/SearchInvitePage";

//Dashboard
import OnBoarding from "./Pages/SmartHome/OnBoarding";
import EarlyUserDashboard from "./Pages/SmartHome/EarlyUserDashboard";
import HomePage from "./Pages/SmartHome/HomePage";

//ProviderProfile
import NewBusinessPage from "./Pages/ProviderProfile/NewBusinessPage";
import BusinessDetails from "./Pages/ProviderProfile/BusinessDetails";
import ReviewsPage from "./Pages/ProviderProfile/Reviews/ReviewsPage";
import EditBusiness from "./Pages/ProviderProfile/EditBusiness";

//Chat
import Chat from "./Pages/Chat/Chat";

//Notifications
import Notifications from "./Pages/Notifications/Notifications";

//MyNetwork
import NetworkPage from "./Pages/MyNetwork/NetworkPage";

//Businesses
import AddBusinessPage from "./Pages/BusinessCreate/AddBusinessPage";

import BusinessAdminPage from "./Pages/BusinessAdmin/BusinessAdminPage";

//feedback
import WriteReview from "./Components/WriteReview/WriteReview";
import ReviewCommentsPage from "./Pages/ProviderProfile/Reviews/ReviewCommentsPage";
import Footer from "./Components/Footer/Footer";

//oauth
import OAuthCallback from './Pages/OAuthCallback/OAuthCallback';

function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://mui.com/">
        Revfer
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

export default function App() {
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
  console.log("authstatus in app.js", authStatus);
  
  // 🆕 Conditional spacing based on mobile and auth status
  const getContentSpacing = () => {
    // Mobile authenticated users have minimal top bar + bottom navigation
    if (isMobile && authStatus === "authenticated") {
      return {
        mt: '48px', // Space for minimal mobile header (48px height)
        pb: '60px' // Padding for bottom navigation
      };
    }
    // Desktop or mobile unauthenticated users have full top header
    return {
      mt: 8, // Standard top margin for full header (64px)
      pb: 0
    };
  };

  return (
    <Box sx={{
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
    }}>
      <Header />
      <Box 
        sx={{ 
          ...getContentSpacing(), // 🆕 Conditional spacing
          bgcolor: "#F8F9F9",
          flex: 1
        }}
      >
        <Routes>
          <Route exact path="/" element={<SignIn />} />
          <Route exact path="/auth/signin" element={<SignIn />} />
          <Route exact path="/auth/signout" element={<SignOut />} />

          <Route
            path="/comingsoon"
            element={
              <RouteGuard redirectTo="/auth/signin">
                <ComingSoon />
              </RouteGuard>
            }
          />

          <Route
            path="/premium"
            element={
              <RouteGuard redirectTo="/auth/signin">
                <Pricing />
              </RouteGuard>
            }
          />

          <Route
            path="/subscription-success"
            element={
              <RouteGuard redirectTo="/auth/signin">
                <SubscriptionSuccessPage />
              </RouteGuard>
            }
          />

          <Route
            path="/feedback"
            element={
              <RouteGuard redirectTo="/auth/signin">
                <WriteReview />
              </RouteGuard>
            }
          />

          <Route
            path="/business/admin/:businessId"
            element={
              <RouteGuard redirectTo="/auth/signin">
                <BusinessAdminPage />
              </RouteGuard>
            }
          />



          <Route
            path="/business/:businessId/drafts"
            element={
              <RouteGuard redirectTo="/auth/signin">
                <DraftApprovalPage />
              </RouteGuard>
            }
          />  

          <Route
            path="/business/:businessId/social/content"
            element={
              <RouteGuard redirectTo="/auth/signin">
                <SocialContentPage />
              </RouteGuard>
            }
          />  

          <Route
            path="/business/:businessId/social/accounts"
            element={
              <RouteGuard redirectTo="/auth/signin">
                <SocialAccountsPage />
              </RouteGuard>
            }
          />  

          <Route
            path="/business/:businessId/knowledge-base"
            element={
              <RouteGuard redirectTo="/auth/signin">
                <BusinessKnowledgeBasePage />
              </RouteGuard>
            }
          />  

          <Route
            path="/onboarding"
            element={
              <RouteGuard redirectTo="/auth/signin">
                <OnBoarding />
              </RouteGuard>
            }
          />

          <Route
            path="/earlyuserdashboard"
            element={
              <RouteGuard redirectTo="/auth/signin">
                <EarlyUserDashboard />
              </RouteGuard>
            }
          />

          <Route
            path="/home"
            element={
              <RouteGuard redirectTo="/auth/signin">
                <HomePage />
              </RouteGuard>
            }
          />

          <Route
            path="/profile/:userId/active"
            element={
              <RouteGuard redirectTo="/auth/signin">
                <ActiveUserProfile />
              </RouteGuard>
            }
          />

          <Route
            path="/chat"
            element={
              <RouteGuard redirectTo="/auth/signin">
                <Chat />
              </RouteGuard>
            }
          />

          <Route
            path="/notifications"
            element={
              <RouteGuard redirectTo="/auth/signin">
                <Notifications />
              </RouteGuard>
            }
          />

          <Route
            path="/company/new"
            element={
              <RouteGuard redirectTo="/auth/signin">
                <AddBusinessPage />
              </RouteGuard>
            }
          />

          <Route
            path="/network"
            element={
              <RouteGuard redirectTo="/auth/signin">
                <NetworkPage />
              </RouteGuard>
            }
          />

          <Route
            path="/usersearch"
            element={
              <RouteGuard redirectTo="/auth/signin">
                <SearchInvitePage />
              </RouteGuard>
            }
          />

          <Route
            path="/business/:businessId/edit"
            element={
              <RouteGuard redirectTo="/auth/signin">
                <EditBusiness />
              </RouteGuard>
            }
          />

          <Route
            path="/oauth/callback/:platform"
            element={
              <RouteGuard redirectTo="/auth/signin">
                <OAuthCallback />
              </RouteGuard>
            }
          />
          <Route path="/roi-calculator" element={<ROICalculatorPage />} />
          <Route path="/legal/about" element={<AboutPage />} />            
          <Route path="/legal/community-guidelines" element={<CommunityGuidelinesPage />} />  
          <Route path="/legal/cookie-policy" element={<CookiePolicyPage />} />  
          <Route path="/legal/terms-of-service" element={<TermsOfServicePage />} />  
          <Route path="/legal/privacy-policy" element={<PrivacyPolicyPage />} />  
          <Route path="/searchresults" element={<SearchResultsPage />} />
          <Route path="/find" element={<FindBusinessPage />} />
          <Route path="/review/comments/:reviewId"  element={<ReviewCommentsPage />} />
          <Route path="/business/:businessId/:title" element={<BusinessDetails />} />
          <Route path="/business/:businessId/reviews" element={<ReviewsPage />} />
          <Route path="/business/new/:businessId/:title" element={<NewBusinessPage />} />

          <Route exact path="/landing/business" element={<BusinessLandingPage />}/>
          <Route exact path="/landing/startups" element={<StartupLandingPage />} />
          <Route exact path="/landing/users" element={<LandingUsersPage />}/>
          <Route exact path="/landing/ai-tools" element={<BusinessLandingPage />}/>
          <Route path="/demo" element={<Demo />} /> 
          <Route path="/blog" element={<BlogListPage />} />
          <Route path="/blog/:slug" element={<BlogDetailPage />} />
          <Route path="/approve/:token" element={<TokenRedirectPage action="approve" />} />
          <Route path="/reject/:token"  element={<TokenRedirectPage action="reject"  />} />
          <Route path="/review/:token"  element={<BatchReview />} />
          <Route path="/r/:code" element={<AffiliateRedirect />} />  
          <Route path="/affiliates" element={<AffiliatesPage />} />
          <Route path="/s/:slug" element={<PreviewRedirect />} />  
          <Route path="/m" element={<MarketingRedirect />} />

          
          <Route path="/founders-circle" element={<FoundersCirclePage />} />

        </Routes>
      </Box>
      <Footer />
    </Box>
  );
}